export const TABS = {
  COMMENTS: 'comments',
  TASKS: 'tasks',
  CALENDAR: 'calendar',
  APPROVALS: 'approvals',
  CAMPAIGN_SPECIALIST: 'campaignSpecialist'
};